import { render } from "./ModalVideo.vue?vue&type=template&id=0ab3a92a"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"

import "./ModalVideo.vue?vue&type=style&index=0&id=0ab3a92a&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__